/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(".happy-customers-section");

  sections.forEach(function (section) {

    const slider = section.querySelector(".testimonial-slider");
    const track = section.querySelector(".testimonial-track");
    const prevButton = section.querySelector(".testimonial-prev");
    const nextButton = section.querySelector(".testimonial-next");

    if (!slider || !track || !prevButton || !nextButton) {
      return;
    }


    /* =========================================
       ORIGINAL CARDS
    ========================================= */

    const originalCards = Array.from(
      track.querySelectorAll(".testimonial-card")
    );

    const originalCount = originalCards.length;

    if (originalCount < 2) {
      return;
    }


    /*
      We clone 3 cards on both sides.

      This is important because desktop shows
      2.5 cards at a time.
    */

    const cloneCount = Math.min(3, originalCount);


    /* =========================================
       CLONE LAST CARDS TO BEGINNING
    ========================================= */

    const startClones = originalCards
      .slice(-cloneCount)
      .map(function (card) {

        const clone = card.cloneNode(true);

        clone.classList.add("testimonial-clone");

        return clone;

      });


    startClones.reverse().forEach(function (clone) {

      track.insertBefore(
        clone,
        track.firstChild
      );

    });


    /* =========================================
       CLONE FIRST CARDS TO END
    ========================================= */

    const endClones = originalCards
      .slice(0, cloneCount)
      .map(function (card) {

        const clone = card.cloneNode(true);

        clone.classList.add("testimonial-clone");

        return clone;

      });


    endClones.forEach(function (clone) {

      track.appendChild(clone);

    });


    /* =========================================
       CURRENT INDEX

       Original first card starts after
       the 3 cloned cards.
    ========================================= */

    let currentIndex = cloneCount;

    let isAnimating = false;

    let autoSlide;


    /* =========================================
       GET CARD STEP
    ========================================= */

    function getStep() {

      const card = track.querySelector(".testimonial-card");

      if (!card) {
        return 0;
      }

      const cardWidth =
        card.getBoundingClientRect().width;

      const trackStyles =
        window.getComputedStyle(track);

      const gap =
        parseFloat(trackStyles.columnGap) || 0;

      return cardWidth + gap;
    }


    /* =========================================
       SET POSITION
    ========================================= */

    function setPosition(animate) {

      const step = getStep();

      if (!step) {
        return;
      }

      if (animate) {

        track.style.transition =
          "transform 0.55s ease";

      } else {

        track.style.transition =
          "none";

      }


      const translateX =
        currentIndex * step;


      track.style.transform =
        "translate3d(-" +
        translateX +
        "px, 0, 0)";

    }


    /* =========================================
       INITIAL POSITION

       Start from REAL first card,
       not the clone.
    ========================================= */

    setPosition(false);


    /*
      Force browser to apply initial position
      before enabling animation.
    */

    track.offsetHeight;


    /* =========================================
       NEXT SLIDE
    ========================================= */

    function nextSlide() {

      if (isAnimating) {
        return;
      }


      isAnimating = true;

      currentIndex++;

      setPosition(true);

    }


    /* =========================================
       PREVIOUS SLIDE
    ========================================= */

    function previousSlide() {

      if (isAnimating) {
        return;
      }


      isAnimating = true;

      currentIndex--;

      setPosition(true);

    }


    /* =========================================
       TRANSITION END

       This is the important part.

       When we reach cloned cards,
       silently move back to the real cards.

       User will NOT see the jump.
    ========================================= */

    track.addEventListener(
      "transitionend",
      function (event) {

        if (
          event.propertyName !== "transform"
        ) {
          return;
        }


        isAnimating = false;


        /*
          We reached the cloned FIRST cards.

          Example:

          REAL:
          1 2 3 4 5

          CLONED:
          1 2 3

          When slider reaches cloned 1,
          silently move back to real 1.
        */

        if (
          currentIndex >=
          cloneCount + originalCount
        ) {

          currentIndex = cloneCount;

          setPosition(false);

        }


        /*
          We reached cloned LAST cards
          while going backwards.

          Silently move to real last cards.
        */

        else if (
          currentIndex < cloneCount
        ) {

          currentIndex =
            cloneCount + originalCount - 1;

          setPosition(false);

        }

      }
    );


    /* =========================================
       ARROW EVENTS
    ========================================= */

    nextButton.addEventListener(
      "click",
      function () {

        nextSlide();

        restartAutoSlide();

      }
    );


    prevButton.addEventListener(
      "click",
      function () {

        previousSlide();

        restartAutoSlide();

      }
    );


    /* =========================================
       AUTO SLIDER
    ========================================= */

    function startAutoSlide() {

      autoSlide = setInterval(
        function () {

          nextSlide();

        },
        4000
      );

    }


    function restartAutoSlide() {

      clearInterval(autoSlide);

      startAutoSlide();

    }


    startAutoSlide();


    /* =========================================
       PAUSE ON HOVER
    ========================================= */

    slider.addEventListener(
      "mouseenter",
      function () {

        clearInterval(autoSlide);

      }
    );


    slider.addEventListener(
      "mouseleave",
      function () {

        clearInterval(autoSlide);

        startAutoSlide();

      }
    );


    /* =========================================
       RESIZE

       Recalculate card position.
    ========================================= */

    window.addEventListener(
      "resize",
      function () {

        setPosition(false);

      }
    );


    /* =========================================
       TOUCH / SWIPE SUPPORT
    ========================================= */

    let touchStartX = 0;

    let touchEndX = 0;


    slider.addEventListener(
      "touchstart",
      function (event) {

        touchStartX =
          event.changedTouches[0].screenX;

      },
      { passive: true }
    );


    slider.addEventListener(
      "touchend",
      function (event) {

        touchEndX =
          event.changedTouches[0].screenX;


        const swipeDistance =
          touchStartX - touchEndX;


        if (Math.abs(swipeDistance) < 50) {
          return;
        }


        if (swipeDistance > 0) {

          nextSlide();

        } else {

          previousSlide();

        }


        restartAutoSlide();

      },
      { passive: true }
    );

  });

});


/* =========================================
   MOBILE CUSTOMER REVIEWS
========================================= */

document.addEventListener("DOMContentLoaded", function () {

  const mobileSection =
    document.querySelector(".mobile-customer-reviews");

  if (!mobileSection) {
    return;
  }

  const cards =
    Array.from(
      mobileSection.querySelectorAll(
        ".mobile-review-card"
      )
    );

  const button =
    mobileSection.querySelector(
      ".mobile-show-more"
    );

  if (!cards.length || !button) {
    return;
  }

  /* -----------------------------------------
     SETTINGS
  ----------------------------------------- */

  const initialCards = 6;
  const cardsPerClick = 3;

  let visibleCount = initialCards;

  /* -----------------------------------------
     UPDATE CARDS
  ----------------------------------------- */

  function updateCards() {

    cards.forEach(function (card, index) {

      if (index < visibleCount) {

        card.classList.remove("is-hidden");

      } else {

        card.classList.add("is-hidden");

      }

    });

    /* -----------------------------------------
       BUTTON TEXT
    ----------------------------------------- */

    button.textContent = "Show More";

  }

  /* -----------------------------------------
     BUTTON CLICK
  ----------------------------------------- */

  button.addEventListener(
    "click",
    function () {

      /*
        If all cards are currently visible,
        start again from first 6.
      */

      if (visibleCount >= cards.length) {

        visibleCount = initialCards;

        updateCards();

        /*
          Scroll back to the beginning
          of reviews smoothly.
        */

        mobileSection.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        return;
      }

      /*
        Show next 3 cards
      */

      visibleCount += cardsPerClick;

      /*
        Don't exceed total cards
      */

      if (visibleCount > cards.length) {
        visibleCount = cards.length;
      }

      updateCards();

    }
  );

  /* -----------------------------------------
     INITIAL STATE
  ----------------------------------------- */

  updateCards();

});